jQuery(function($) {

  // Move mega menus from section to menu
  $('.site-nav__link').each(function () {
    const megaSlug = $(this).data('nav-item');
    if ($(`#mega-menu-${megaSlug}`).length) {
      $(`#mega-menu-${megaSlug}`).insertAfter(`#mega-menu-parent-${megaSlug}`);
      $(`#mega-menu-parent-${megaSlug}`).addClass('has-mega');
    }
  });

  // Remove all mega menu section divs after loading
  $('.mega-menu-section').remove();

  $('.close-mega').on('click', function () {
    closeMegaMenu();
  });

  function closeMegaMenu() {
    $('header').removeClass('mega-active');
    $('.mega-menu').removeClass('mega-active');
    $('.site-nav__link').removeClass('mega-link-active');
    $('.mega-menu__content').removeClass('active');
    $('div.overlay').removeClass('visible');
    $('.mega-menu__content-wrapper .mega-menu__content:first-of-type').addClass('active');
  }

  $('div.overlay').on('click', function() {
    closeMegaMenu();
  });

    // Prevent closing when hovering within the header
    $('header[role="banner"]').on('mouseleave', function () {
      closeMegaMenu();
    });
    //Desktop Hover
    $('.site-nav__link').on('mouseenter', function () {
      if ($(window).width() > 768) { // Ensure hover is only for desktop
        const menuSlug = $(this).data('nav-item');
        if ($(`#mega-menu-${menuSlug}`).length) {
          // Remove transition for all mega menus
          $('.mega-menu').each(function () {
            this.style.setProperty('transition', 'none', 'important');
          });

          // Open the new menu
          $(`#mega-menu-${menuSlug}`).addClass('mega-active');
          $('.mega-menu__content').removeClass('active');
          $('.mega-menu__child_link').removeClass('active');
          $('.mega-menu__content-wrapper .mega-menu__content:first-of-type').addClass('active');
          $('div.overlay').addClass('visible');
          $('header').addClass('mega-active');
          $('.site-nav__link').removeClass('mega-link-active');
          $(this).addClass('mega-link-active');

          // Close other menus
          $('.mega-menu').not(`#mega-menu-${menuSlug}`).removeClass('mega-active');
        }
      }
    });

    // Adjust closing logic for menus
    $('.mega-menu').on('mouseleave', function () {
      if ($(window).width() > 768) {
        // Check if still hovering on header
        if (!$('header[role="banner"]:hover').length) {
          closeMegaMenu();
          // Restore the transition property for all mega menus
          $('.mega-menu').each(function () {
            this.style.removeProperty('transition');
          });
        }
      }
    });

  // Hover interaction for child-link--has-submenu
  $('.child-link--has-submenu .mega-menu__child_link.has-children:not(.all-link)').on('mouseenter', function () {
    if ($(window).width() > 768) { // Only trigger on desktop
      const menuSlug = $(this).data('link-item');
      const childSlug = $(this).data('child-link-item');

      if (!$(this).hasClass('active')) {
        $(`#mega-menu-${menuSlug} .mega-menu__child_link`).removeClass('active');
        $('.mega-menu__content').removeClass('active');
        $(`#mega-menu-${menuSlug} #mega-menu-content-${childSlug}`).addClass('active');
        $('#header-nav__wrapper').addClass('sub-menu-active');
        $(this).addClass('active');
      }
    }
  });

  // Click functionality remains unchanged
  $('.site-nav__link').on('click', function (e) {
    const menuSlug = $(this).data('nav-item');
    if ($(`#mega-menu-${menuSlug}`).length) {
      e.preventDefault();
      if ($(this).hasClass('mega-link-active')) {
        closeMegaMenu();
      } else {
        $('.mega-menu__content').removeClass('active');
        $('.mega-menu__child_link').removeClass('active');
        $('.mega-menu__content-wrapper .mega-menu__content:first-of-type').addClass('active');
        $('div.overlay').addClass('visible');
        $('header').addClass('mega-active');
        $('.site-nav__link').removeClass('mega-link-active');
        $(this).addClass('mega-link-active');
        $('.mega-menu').removeClass('mega-active');
        $(`#mega-menu-${menuSlug}`).addClass('mega-active');
      }
    }
  });

  // Existing mobile functionality remains untouched
  $('.mobile-nav-trigger').on('click', function (e) {
    e.preventDefault();
    console.log('clicked men')
    if (!$(this).hasClass('trigger-active')) {
      openMobileMenu();
    } else {
      closeMobileMenu();
    }
  });

  $('.mobile-search-btn').on('click', function (e) {
    e.preventDefault();
    console.log('clicked search')
    openMobileMenu();
    setTimeout( function() {
      $('#mobile-search input').focus()
    }, 500)
  })

  function openMobileMenu() {
    $('.mobile-nav-trigger').addClass('trigger-active');
    $('#header-nav__wrapper').show();
    $('header').addClass('mega-active');
    $('body').addClass('no-scroll');
    let headerHeight = $('header').outerHeight();
    const mobileSearchHeight = $('#mobile-search').outerHeight();
    const alertHeight = $('#alert-bar').length ? $('#alert-bar').outerHeight() : 0;
    const countdownHeight = $('.countdown-text').length ? $('.countdown-text').outerHeight() : 0;
    headerHeight += alertHeight + countdownHeight;
    const heightOffset = headerHeight + mobileSearchHeight;
    $('#mobile-menu').hide();
    $('#header-nav__wrapper, .findify-layouts--autocomplete--dropdown').css({ height: window.innerHeight - headerHeight + 'px', top: headerHeight + 'px' });
    $('.mega-menu__content:not(.mega-menu__content-images)').height(window.innerHeight - heightOffset + 'px');
    $('#header-nav__wrapper').removeClass('sub-menu-active').addClass('active');
  }

  function closeMobileMenu() {
    $('.mobile-nav-trigger').removeClass('trigger-active');
    $('#header-nav__wrapper').removeClass('active');
    $('.mega-menu').slideUp();
    $('.mega-menu__mobile-link').removeClass('active');
    $('#header-nav__wrapper').removeClass('sub-menu-active');
    $('body').removeClass('no-scroll');
  }

  $('.mega-menu__mobile-link.has-mega').on('click', function (e) {
    e.preventDefault();
    const $menuItem = $(this);
    $('.mega-menu').not($(this).next('.mega-menu')).slideUp();
    $(this).next('.mega-menu').slideToggle(300);
    // put sub menu in view
    setTimeout(function () {
      $('#mega-menu__scroll').animate({ scrollTop: $('#mega-menu__scroll').scrollTop() + $($menuItem).position().top - 10 });
    }, 550);
    $(this).toggleClass('active');
  });

  $('.child-link--has-submenu .mega-menu__child_link.has-children:not(.all-link)').on('click', function (e) {
    e.preventDefault();
    const menuSlug = $(this).data('link-item');
    const childSlug = $(this).data('child-link-item');

    if ($(this).hasClass('active')) {
      const $imagesDiv = $(this).closest('.mega-menu').find('.mega-menu__content-images');
      if ($imagesDiv.length) {
        $(this).removeClass('active');
        $(`#mega-menu-${menuSlug} .mega-menu__child_link`).removeClass('active');
        $('.mega-menu__content').removeClass('active');
        $imagesDiv.addClass('active');
        $('#header-nav__wrapper').removeClass('sub-menu-active');
      }
    } else {
      $(`#mega-menu-${menuSlug} .mega-menu__child_link`).removeClass('active');
      $('.mega-menu__content').removeClass('active');
      $(`#mega-menu-${menuSlug} #mega-menu-content-${childSlug}`).addClass('active');
      $('#header-nav__wrapper').addClass('sub-menu-active');
      $(this).addClass('active');
    }
  });

  $('.prev-child-menu').on('click', function () {
    $('#header-nav__wrapper').removeClass('sub-menu-active');
    setTimeout(function () {
      // reset position of child scroll
      $('.mega-menu__content-inner').scrollTop(0);
      $('.mega-menu__content:not(.mega-menu__content-images)').hide();
    }, 500);
  });

  $('#nav-search').on('click', function () {
    $('#search').toggleClass('active');
    if ($('#search').hasClass('active')) {
      setTimeout(function () {
        $('#search input').focus();
      }, 1000);
    }
  });

  $(window).scroll(function () {
    $('#search').removeClass('active');
  });

  const mobileSearchForm = document.querySelector('#mobile-search form');
  mobileSearchForm.addEventListener("submit", function() {
    if (window.location.href.indexOf("search-results") > -1) {
      closeMobileMenu();
    }
  });
});
